import { adminHttpClient } from '../../commons/adminHttpClient'

export type PlansAndSeatsResponse = {
  all: PlansAndSeatsReport[]
  group: PlansAndSeatsReport[]
  qsehraMonthly: PlansAndSeatsReport[]
  qsehraAnnual: PlansAndSeatsReport[]
}

export type PlansAndSeatsReport = {
  companyName: string
  planName: string
  renewalDate: string
  adminName: string
  adminEmail: string
  numberOfSeats: number
  recurlyNumberOfSeats: number
  currentBaseFee: number
  currentSeatFee: number
  state: string
}

type PlansAndSeatsRequest = {
  dateOfWeek?: string
  isLastReport: boolean
}
export const getPlansAndSeatsReport = (request: PlansAndSeatsRequest): Promise<any> => {
  return adminHttpClient.get('/Csi/PlansAndSeatsReport', request)
}
